define('lq/events/actions/reportCommand',[
    'lq/events/actions/eventAction',
    'lq',
    'when'
], function (EventAction, lq, when) {
    'use strict';

    var pollDelayInMilliseconds = 1000;
    
    function ReportCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    };

    EventAction.extend(ReportCommand, EventAction);

    ReportCommand.typeName = 'ReportCommand';

    ReportCommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };
    
    ReportCommand.prototype.execute = function (continuation) {
        var self = this;
        this.continuation = continuation;

        this.piping.dispatcher
            .dispatchToAbsoluteUrl(this.getReportUrl(), this.getDispatchData())
            .then(function (response) {
                if (!response.ticketNumber) {
                    // "generate in the background" is probably enabled
                    continuation();
                } else {
                    self.handleReport(response.ticketNumber);
                }
            })
            .catch(function () {
                alert("Something went wrong while creating the report.");
            });
    };

    ReportCommand.prototype.getReportUrl = function () {
        return this.piping.url.prepare(lq.getTenantUrl("Report/"), {});
    };

    ReportCommand.prototype.getDispatchData = function () {
        return {
            actionId: this.rootDrop.data.id,
            commandId: this.eventData.command,
            globalParameters: this.piping.parameters.globals.getAll(),
            localParameters: this.piping.parameters.locals.getAll(),
        };
    };

    ReportCommand.prototype.handleReport = function (ticketNumber) {
        var self = this;

        return when.promise(function (resolve) {
            self.poll(resolve, ticketNumber);
        });
    };

    ReportCommand.prototype.poll = function (resolve, ticketNumber) {
        var self = this;

        setTimeout(function () {
            resolve(
                self.isReady(ticketNumber).always(function (data, textStatus, xhr) {
                    self.handleStatus(xhr.status, ticketNumber, data);
                })
            );
        }, pollDelayInMilliseconds);
    };

    ReportCommand.prototype.isReady = function (ticketNumber) {
        return $.get({
            url: lq.getTenantUrl("Report/IsReady"),
            data: {
                ticketNumber: ticketNumber,
            },
            cache: false,
        });
    };

    ReportCommand.prototype.handleStatus = function (status, ticketNumber, data) {
        if (status === 202) {
            return this.handleReport(ticketNumber, this.isReady);
        } else if (status === 200) {
            this.finishReport(ticketNumber, data);
        }
    };

    ReportCommand.prototype.finishReport = function (ticketNumber, data) {
        if (data.isDirty) {
            this.handleExecutionTrailDirty(this.continuation);
        } else {
            this.downloadReport(ticketNumber, data);
            this.setParameters(data);

            this.continuation();
        }
    };

    ReportCommand.prototype.downloadReport = function (ticketNumber, data) {
        if (data.download) {
            var url = data.url 
                ?
                this.piping.url.prepare(lq.getTenantUrl("DynamicContent/DownloadFile"), {
                    url: data.url,
                    filename: data.filename,
                    openInBrowser: data.downloadBehaviour !== "download",
                }) 
                :
                this.piping.url.prepare(lq.getTenantUrl("Report/Download"), {
                    ticketNumber: ticketNumber,
                });

            if (data.downloadBehaviour === "openInCurrentTab" || data.downloadBehaviour === "download") {
                window.location = url;
            } else {
                window.open(url + "#toolbar=1");
            }
        }
    };

    ReportCommand.prototype.setParameters = function (data) {
        if (data.entityIdParameter) {
            var targetParameters = data.entityIdParameterIsGlobal
                ? this.piping.parameters.globals
                : this.piping.parameters.locals;

            targetParameters.setValue(data.entityIdParameter, data.entityIdValue);
        }
    };
    
    return ReportCommand;
});

